export class ErrorMessage {
    errorMessage: string;
    isError: boolean;
}
